import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ALLOWED_DASHBOARD_ROLES = ['admin', 'super_admin', 'superadmin', 'organizer'];

/**
 * Wraps dashboard content. Only superadmin, admin, and organizer can access.
 * Organizers are further limited to a subset of routes (see OrganizerPathGuard).
 * Others are redirected to the standalone Profile page.
 */
const AdminOnlyRoute = ({ children }) => {
  const { user } = useAuth();
  const role = typeof user?.role === 'string' ? user.role.toLowerCase().trim() : '';
  const isAllowed = ALLOWED_DASHBOARD_ROLES.some((r) => role === r);

  if (!isAllowed) {
    return <Navigate to="/profile" replace />;
  }

  return children;
};

export default AdminOnlyRoute;
